export default __webpack_public_path__ + "static/media/818.ee90ae14.jpg";